import { EventLink, evColor, fmtTime } from "./EventLink";

const sameDay = (a, b) => a.toDateString() === b.toDateString();
const evDay = (ev) => new Date(ev.all_day ? `${ev.start}T00:00:00` : ev.start);

export default function MonthGrid({ days, month, events, leads, onDay }) {
  return (
    <div className="panel overflow-hidden" data-testid="calendar-monthgrid">
      <div className="grid grid-cols-7 border-b border-[var(--border)]">
        {days.slice(0, 7).map((d) => <div key={d.getDay()} className="text-center text-[11px] uppercase tracking-wide text-neutral-400 py-2">{d.toLocaleDateString([], { weekday: "short" })}</div>)}
      </div>
      <div className="grid grid-cols-7 grid-rows-6">
        {days.map((d) => {
          const evs = events.filter((ev) => sameDay(evDay(ev), d));
          const today = sameDay(d, new Date());
          return (
            <div key={d.toDateString()} className={`min-h-[104px] border-b border-r border-[var(--border)] p-1 min-w-0 ${d.getMonth() !== month ? "bg-black/30" : ""}`}>
              <button onClick={() => onDay(d)} data-testid={`month-day-${d.getMonth() + 1}-${d.getDate()}`}
                className={`mx-auto block w-6 h-6 rounded-full text-xs mb-1 hover:bg-[var(--panel-2)] ${today ? "bg-[#8ab4f8] text-black font-medium" : d.getMonth() !== month ? "text-neutral-600" : "text-neutral-300"}`}>{d.getDate()}</button>
              <div className="space-y-0.5">
                {evs.slice(0, 3).map((ev) => (
                  <EventLink key={ev.id} ev={ev} leads={leads} className="flex items-center gap-1 w-full min-w-0 rounded px-1 py-[1px] text-[11px] text-left hover:bg-[var(--panel-2)]">
                    {ev.all_day ? <span className="truncate rounded px-1 cal-ev w-full" style={{ background: evColor(ev) }}>{ev.title}</span>
                      : <><span className="w-2 h-2 rounded-full shrink-0" style={{ background: evColor(ev) }} /><span className="text-neutral-400 shrink-0 hidden sm:inline">{fmtTime(ev.start)}</span><span className="truncate">{ev.title}</span></>}
                  </EventLink>
                ))}
                {evs.length > 3 && <button onClick={() => onDay(d)} className="text-[11px] text-neutral-400 hover:text-white px-1" data-testid={`month-more-${d.getMonth() + 1}-${d.getDate()}`}>{evs.length - 3} more</button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
